import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { AnalyticalPanel } from '@atlas/ui';
import { GLOSSARY_TERMS } from '@atlas/glossary';
import { ExplainActions, PageHeader } from '../../components/shared';
import { PageSkeleton } from '../../components/PageSkeleton';
import { api } from '../../lib/api';

export function GlossaryPage() {
  const [q, setQ] = useState('');
  const { data, isLoading } = useQuery({ queryKey: ['glossary'], queryFn: api.glossary });

  if (isLoading) return <PageSkeleton blocks={4} />;

  const query = q.trim().toLowerCase();
  const entries = (query
    ? GLOSSARY_TERMS.filter((entry) =>
        [entry.term, entry.slug, ...entry.aliases].some((value) => value.toLowerCase().includes(query)),
      )
    : GLOSSARY_TERMS
  ).slice(0, 24);

  return (
    <div className="space-y-6">
      <PageHeader title="Glossary" subtitle={`${GLOSSARY_TERMS.length} canonical entries · concept atlas`} />
      <ExplainActions screenName="Glossary" />

      <input
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search terms and aliases…"
        className="w-full max-w-md rounded-[var(--radius-control)] border border-[var(--color-border-strong)] bg-[var(--color-surface-1)] px-3 py-2 text-sm text-[var(--color-text-primary)]"
        aria-label="Search glossary"
      />

      <div className="grid gap-3 md:grid-cols-2">
        {entries.map((entry) => (
          <AnalyticalPanel key={entry.termId} title={entry.term} subtitle={entry.category.replace('_', ' ')}>
            <p className="text-sm text-[var(--color-text-secondary)]">
              Canonical Atlas concept with interpretation rules, limitations, and citations.
            </p>
            <Link
              to="/glossary/$slug"
              params={{ slug: entry.slug }}
              className="mt-2 inline-block text-sm text-[var(--color-signal-cyan)]"
            >
              Read full entry →
            </Link>
          </AnalyticalPanel>
        ))}
      </div>

      {data && (
        <p className="text-xs text-[var(--color-text-muted)]">Registry entries: {data.entries.length}</p>
      )}
    </div>
  );
}
